import { Box } from "@material-ui/core"
import type { ReactElement } from "react"
import { Body1 } from "../../atoms"
import { useCompanyName } from "../../../hooks"

import "./page-footer.styles.scss"

export function PageFooter(): ReactElement {
  const companyName = useCompanyName()
  return (
    <Box className="page-footer" display="flex" justifyContent="center" padding="1.6rem">
      <Body1>&copy; {companyName} {new Date().getFullYear()}</Body1>
    </Box>
  )
}
